import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import { ChurnFlowSolutionCardI, ChurnReason } from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-too-expensive-page',
  templateUrl: './churn-too-expensive-page.component.html',
  styleUrls: ['./churn-too-expensive-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnTooExpensivePageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.TooExpensive;
  public readonly displayDownsellSolution = this.churnFlowDataService.displayDownsellSolution;

  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.TooExpensive);

  public readonly speakWithSpecialist: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.incentive_1'),
      this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.incentive_2'),
      this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.incentive_3'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.cta'),
  };

  public readonly switchToLowerPlan: ChurnFlowSolutionCardI = {
    iconVariant: 'currency-exchange',
    title: this.t('tlc.churn_flow.steps.too_expensive.solutions.switch_to_lower_plan.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.too_expensive.solutions.switch_to_lower_plan.incentive_1'),
      this.t('tlc.churn_flow.steps.too_expensive.solutions.switch_to_lower_plan.incentive_2'),
      this.t('tlc.churn_flow.steps.too_expensive.solutions.switch_to_lower_plan.incentive_3'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.too_expensive.solutions.switch_to_lower_plan.cta'),
  };
  // TODO: Commented out at the moment since we're waiting for a proper action here
  // public readonly saveMoreByConsolidating: ChurnFlowSolutionCardI = {
  //   iconVariant: 'tellent',
  //   title: this.t('tlc.churn_flow.steps.too_expensive.solutions.save_more_by_consolidating.title'),
  //   incentives: [
  //     this.t('tlc.churn_flow.steps.too_expensive.solutions.save_more_by_consolidating.incentive_1'),
  //     this.t('tlc.churn_flow.steps.too_expensive.solutions.save_more_by_consolidating.incentive_2'),
  //   ],
  //   ctaText: this.t('tlc.churn_flow.steps.too_expensive.solutions.save_more_by_consolidating.cta'),
  // };

  public speakToASpecialist(): any {
    this.openIntercom(
      this.t('tlc.churn_flow.steps.too_expensive.solutions.speak_with_specialist.intercom_message'),
    );
  }

  public navigateToPlanPicker(): void {
    this.navigationService.navigateToPlanPicker();
  }

  public askAboutConsolidation(): void {
    this.openIntercom(
      this.t(
        'tlc.churn_flow.steps.too_expensive.solutions.save_more_by_consolidating.intercom_message',
      ),
    );
  }
}
